import { pawnshop_reports_reader_service_v4 } from "../../../api/restclient";
import { formatDateParam } from "../lib/makeRequest";
import moment from "moment";

const transformResponse = (response, params) => ({
  key: params,
  value: JSON.parse(response),
});

export const makeRequest = async (endpoint, params, method = "get") => {
  try {
    const response =
      method === "get"
        ? await pawnshop_reports_reader_service_v4.get(endpoint, params, {
            transformResponse: (resp) => {
              const transformedResponse = transformResponse(resp, params);
              return transformedResponse;
            },
          })
        : await pawnshop_reports_reader_service_v4.post(endpoint, params, {
            transformResponse: (resp) => {
              const transformedResponse = transformResponse(resp, params);
              return transformedResponse;
            },
          });
    return response;
  } catch {
    return Promise.resolve();
  }
};

const createParams = (data) => {
  return {
    currentMonth: data.currentMonth,
    currentYear: data.currentYear,
    previousMonth: data.previousMonth,
    previousYear: data.previousYear,
  };
};
const constructArrayParams = (data) => {
  const arrayParams = new URLSearchParams();
  arrayParams.append("currentMonth", data.currentMonth);
  arrayParams.append("currentYear", data.currentYear);
  arrayParams.append("previousMonth", data.previousMonth);
  arrayParams.append("previousYear", data.previousYear);
  return arrayParams;
};

export const average_overall_v4 = (data) => {
  return makeRequest("/sales/average/overall", createParams(data));
};

export const average_by_cluster_v4 = (data) => {
  return makeRequest(
    `/sales/average/cluster/${data.clusterId}`,
    createParams(data)
  );
};

export const average_by_area_v4 = (data) =>
  makeRequest(`/sales/average/area/${data.areaId}`, createParams(data));

export const average_by_branch_v4 = (data) =>
  makeRequest(
    `/sales/average/branches?${constructArrayParams(data)}`,
    data.branch_codes,
    "post"
  );

export const active_overall_v4 = (data) => {
  return makeRequest("/sales/active/overall", {
    coveredDate: formatDateParam(data.covered_date),
  });
};

export const active_by_cluster_v4 = (data) =>
  makeRequest(`/sales/active/cluster/${data.clusterId}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const active_by_area_v4 = (data) =>
  makeRequest(`/sales/active/area/${data.areaId}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const active_by_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append(
    "coveredDate",
    moment(data.covered_date).format("YYYY-MM-DD")
  );
  return makeRequest(
    `/sales/active/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};

export const expired_overall_v4 = (data) => {
  return makeRequest("/sales/expired/overall", {
    coveredDate: formatDateParam(data.covered_date),
  });
};

export const expired_by_cluster_v4 = (data) =>
  makeRequest(`/sales/expired/cluster/${data.clusterId}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const expired_by_area_v4 = (data) =>
  makeRequest(`/sales/expired/area/${data.areaId}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const expired_by_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append(
    "coveredDate",
    moment(data.covered_date).format("YYYY-MM-DD")
  );
  return makeRequest(
    `/sales/expired/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
